import styled, { css } from 'styled-components';

import { MEDIA_SIZE } from '../ahm-constants/ui';

type MediaDisplayProps = {
  up?: boolean;
  media: MEDIA_SIZE;
};

export const MediaDisplay = styled.div<MediaDisplayProps>`
  ${({ theme, media, up }) => {
    const { mediaQueries } = theme;
    const mediaQuery = up ? mediaQueries.below : mediaQueries.above;
    return css`
      ${mediaQuery(theme.media[media])} {
        display: none;
      }
    `;
  }}
`;
